import { createContext } from "react";

export const PhoneContext = createContext(null);
